module.exports = __webpack_public_path__ + "static/img-16-0ec6f96e9d8c2f9583cde36a8a8898e3.jpeg";